export default __webpack_public_path__ + "static/media/reports-hover.de28d4b6.svg";